<template>
  <div class="row">
    <div class="col col-md-6">
      <b-spinner v-if="!data" />
      <div v-if="data" class="card mt-6">
        <div class="card-header" v-label-key="'ABOUT'">
          About
        </div>
        <b-table-simple>
          <b-tr>
            <b-td><span v-label-key="'CREATED'">Created</span></b-td>
            <b-td>{{ createdDate | moment('YYYY-MM-DD') }}</b-td>
          </b-tr>
          <b-tr
            v-if="data.distributor_id"
            v-router-link="{
              name: 'distributor-detail',
              params: { id: data.distributor_id },
            }"
          >
            <b-td><span v-label-key="'DISTRIBUTOR'">Distributor</span></b-td>
            <b-td>{{ data.distributor_name }}</b-td>
          </b-tr>
          <template v-if="section === 'distributors'">
            <b-tr>
              <b-td
                ><span v-label-key="'DASHBOARD_CONTACT_EMAIL'"
                  >Dashboard Email Contact</span
                ></b-td
              >
              <b-td
                ><a
                  v-if="data.dashboard_contact_email"
                  :href="`mailto:${data.dashboard_contact_email}`"
                  >{{ data.dashboard_contact_email }}</a
                ></b-td
              >
            </b-tr>
            <b-tr>
              <b-td
                ><span v-label-key="'WARRANTY_CONTACT_EMAIL'"
                  >Warranty Contact</span
                ></b-td
              >
              <b-td
                ><a
                  v-if="data.warranty_contact_email"
                  :href="`mailto:${data.warranty_contact_email}`"
                  >{{ data.warranty_contact_email }}</a
                ></b-td
              >
            </b-tr>
            <b-tr>
              <b-td><span v-label-key="'LOGO'">Logo</span></b-td>
              <b-td>
                <img
                  v-if="data.logo"
                  :src="'https://cdn.gokaizen.com/' + data.logo"
                  alt=""
                  class="about-img"
                />
              </b-td>
            </b-tr>
            <b-tr>
              <b-td><span v-label-key="'TUTORIAL_LINK'">Tutorial</span></b-td>
              <b-td
                ><a v-if="data.tutorial_link" :href="`${data.tutorial_link}`">{{
                  data.tutorial_link
                }}</a></b-td
              >
            </b-tr>
            <b-tr>
              <b-td><span v-label-key="'EDIT_DISTRIBUTOR_REWARD_LINK'">Reward Link</span></b-td>
              <b-td
                ><a v-if="data.reward_program_link" :href="`${data.reward_program_link}`">{{
                  data.reward_program_link
                }}</a></b-td
              >
            </b-tr>

            <template v-if="auth.user.selectedAccess.roleLevel > 3">
              <b-tr>
                <b-td
                  ><span v-label-key="'APP_ANDROID_ID'"
                    >Android App ID</span
                  ></b-td
                >
                <b-td>{{ data.android_app_id }}</b-td>
              </b-tr>
              <b-tr v-if="data.domain_name">
                <b-td
                  ><span v-label-key="'EDIT_DISTRIBUTOR_DOMAIN_NAME'"></span
                ></b-td>
                <b-td>
                  <a target="_blank" :href="data.domain_name">{{
                    data.domain_name
                  }}</a>
                </b-td>
              </b-tr>
              <b-tr>
                <b-td
                  ><span v-label-key="'EDIT_DISTRIBUTOR_CUSTOM_CSS'"></span
                ></b-td>
                <b-td>
                  <a
                    target="_blank"
                    :href="`https://cdn.gokaizen.com/${data.custom_css}`"
                    >{{ `https://cdn.gokaizen.com/${data.custom_css}` }}</a
                  >
                </b-td>
              </b-tr>
            </template>
          </template>
        </b-table-simple>
      </div>
    </div>
  </div>
</template>

<script>
import $api from '@/services/api';
import $auth from '@/services/auth';

export default {
  name: 'AboutTab',
  props: {
    section: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      data: null,
      auth: $auth,
    };
  },

  computed: {
    createdDate() {
      return this.data && this.data.created;
    },
  },

  created() {
    this.refreshData();
  },

  methods: {
    refreshData() {
      $api
        .get(`/v1/dashboard/${this.section}/${this.$route.params.id}`)
        .then((data) => {
          this.data = data;
        });
    },
  },
};
</script>
<style scoped>
.about-img {
  width: 100px;
}
</style>
